import { render, staticRenderFns } from "./techListInspection.vue?vue&type=template&id=c54c42b2&scoped=true"
import script from "./techListInspection.vue?vue&type=script&lang=js"
export * from "./techListInspection.vue?vue&type=script&lang=js"
import style0 from "./techListInspection.vue?vue&type=style&index=0&id=c54c42b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54c42b2",
  null
  
)

export default component.exports